import React, { useState } from "react";
import "../Event/AdminEvent.css";

interface TransportDto {
    transportId?: number;
    country?: string;
    arrivalDate?: string;
    arrivalTime?: string; // HH:mm
    arrivalFlightNo?: string;
    contactperson?: string;
    contactpersonEmail?: string;
    contactpersonMobile?: string;
    numberOfPersons?: number;
    numberOfLuggage?: number;
    dropOffPlace?: string;
}

const FormTransportCreate: React.FC = () => {
    const [formData, setFormData] = useState<TransportDto>({
        country: "",
        arrivalDate: "",
        arrivalTime: "",
        arrivalFlightNo: "",
        contactperson: "",
        contactpersonEmail: "",
        contactpersonMobile: "",
        numberOfPersons: 0,
        numberOfLuggage: 0,
        dropOffPlace: "",
    });

    const [error, setError] = useState<string | null>(null);
    const [success, setSuccess] = useState<string | null>(null);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: e.target.type === "number" ? Number(value) : value,
        }));
    };

    const validateForm = (): boolean => {
        if (!formData.country?.trim())
            return setError("Country skal udfyldes"), false;

        if (!formData.arrivalDate)
            return setError("Arrival Date skal udfyldes"), false;

        if (!formData.arrivalTime)
            return setError("Arrival Time skal udfyldes"), false;

        if (!formData.arrivalFlightNo?.trim())
            return setError("Flight No skal udfyldes"), false;

        if (!formData.contactperson?.trim())
            return setError("Contact Person skal udfyldes"), false;

        if (!formData.contactpersonEmail?.trim())
            return setError("Email skal udfyldes"), false;

        if (!formData.contactpersonMobile?.trim())
            return setError("Mobile skal udfyldes"), false;

        if (!formData.numberOfPersons || formData.numberOfPersons <= 0)
            return setError("Number of Persons skal være større end 0"), false;

        if (!formData.numberOfLuggage || formData.numberOfLuggage <= 0)
            return setError("Number of Luggage skal være større end 0"), false;

        if (!formData.dropOffPlace?.trim())
            return setError("Drop-off Place skal udfyldes"), false;

        setError(null);
        return true;
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setSuccess(null);

        if (!validateForm()) return;

        const payload = {
            ...formData,
            arrivalTime: `${formData.arrivalTime}:00`, // HH:mm:ss
        };

        try {
            const response = await fetch("/api/form_transport/arrival", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                const text = await response.text();
                throw new Error(text || "Fejl ved oprettelse af transport");
            }

            await response.json();
            setSuccess("✅ Transport oprettet succesfuldt!");

            setFormData({
                country: "",
                arrivalDate: "",
                arrivalTime: "",
                arrivalFlightNo: "",
                contactperson: "",
                contactpersonEmail: "",
                contactpersonMobile: "",
                numberOfPersons: 0,
                numberOfLuggage: 0,
                dropOffPlace: "",
            });
        } catch (err: any) {
            setError(`Fejl: ${err.message}`);
        }
    };

    return (
        <div className="form-container">
            <h2>Transport Arrival request</h2>

            {error && <p className="error-message">{error}</p>}
            {success && <p className="success-message">{success}</p>}

            <form onSubmit={handleSubmit}>
                <label>Country *</label>
                <input type="text" name="country" value={formData.country} onChange={handleChange} />

                <label>Arrival Date *</label>
                <input type="date" name="arrivalDate" value={formData.arrivalDate} onChange={handleChange} />

                <label>Arrival Time *</label>
                <input type="time" name="arrivalTime" value={formData.arrivalTime} onChange={handleChange} />

                <label>Flight No *</label>
                <input type="text" name="arrivalFlightNo" value={formData.arrivalFlightNo} onChange={handleChange} />

                <label>Contact Person *</label>
                <input type="text" name="contactperson" value={formData.contactperson} onChange={handleChange} />

                <label>Email *</label>
                <input type="email" name="contactpersonEmail" value={formData.contactpersonEmail} onChange={handleChange} />

                <label>Mobile *</label>
                <input type="text" name="contactpersonMobile" value={formData.contactpersonMobile} onChange={handleChange} />

                <label>Number of Persons *</label>
                <input type="number" name="numberOfPersons" min={1} value={formData.numberOfPersons} onChange={handleChange} />

                <label>Number of Luggage *</label>
                <input type="number" name="numberOfLuggage" min={1} value={formData.numberOfLuggage} onChange={handleChange} />

                <label>Drop-off Place *</label>
                <input type="text" name="dropOffPlace" value={formData.dropOffPlace} onChange={handleChange} />

                <button type="submit" className="add-btn">
                    Opret Transport
                </button>
            </form>
        </div>
    );
};

export default FormTransportCreate;
